export enum APInvoiceStatus {
  DRAFT = "DRAFT",
  MATCHED = "MATCHED",
  FINALIZED = "FINALIZED",
  VOID = "VOID",
}

export enum PaymentStatus {
  UNPAID = "unpaid",
  PARTIALLY_PAID = "partially_paid",
  PAID = "paid",
  OVERPAID = "overpaid",
}

/**
 * Status of synchronization to external origin systems (e.g., Famous ERP)
 * Used to track the lifecycle of syncing entities to external systems
 */
export enum OriginSyncStatus {
  NotStarted = "not_started",
  Pending = "pending",
  InProgress = "in_progress",
  Success = "success",
  Failed = "failed",
  Retrying = "retrying",
}

/**
 * Type of external payment for invoices that are paid outside of Gently
 * (e.g., customer has set up auto-pay directly with the vendor)
 */
export enum ExternalPaymentType {
  /** Automatic payment set up by customer with vendor (e.g., utility bills) */
  Autopay = "autopay",
  /** Recurring scheduled payment */
  Recurring = "recurring",
  /** Manual payment made outside of Gently */
  ManualExternal = "manual_external",
}
